<div class="latlong-div row" *ngIf="positionReady">
  <google-map
    class="map"
    height="400px"
              width="100%"
              [center]="centerLatLng"
              [zoom]="zoom"
              (mapClick)="moveMap($event)"
              (mapMousemove)="move($event)">
    <map-marker [position]="centerLatLng"
                [options]="markerOptions"></map-marker>
  </google-map>
  <!-- div>Latitude: {{display?.lat}}</div>
  <div>Longitude: {{display?.lng}}</div -->
</div>
<div class="latlong-div row" *ngIf="!positionReady">
  <p>Cargando...</p>
  <!-- img src="{{ images. }}" alt="loader" -->
</div>
